import React from 'react';
import { Route, Routes, useOutletContext } from 'react-router-dom';

import StudyReportShell from './StudyReportShell';
import { StudyReportScrollNavAttachmentInsets } from './StudyReportSectionsLayout';
import StudyReportWorkspace from './StudyReportWorkspace';

type StudyReportRouteContext = {
  selectedStudyId?: string;
  selectedStudyIds?: string[];
  hasAvailableStudies: boolean;
  onCreateStudy?: () => void;
  scrollNavAttachmentInsets?: StudyReportScrollNavAttachmentInsets;
};

const StudyReportRouteIndex: React.FunctionComponent<React.PropsWithChildren<unknown>> = () => {
  const { selectedStudyId, selectedStudyIds, hasAvailableStudies, onCreateStudy, scrollNavAttachmentInsets } =
    useOutletContext<StudyReportRouteContext>();

  return (
    <StudyReportWorkspace
      selectedStudyId={selectedStudyId}
      selectedStudyIds={selectedStudyIds}
      hasAvailableStudies={hasAvailableStudies}
      onCreateStudy={onCreateStudy}
      scrollNavAttachmentInsets={scrollNavAttachmentInsets}
    />
  );
};

const StudyReportRoutes: React.FunctionComponent<React.PropsWithChildren<unknown>> = () => {
  return (
    <Routes>
      <Route element={<StudyReportShell />}>
        <Route index element={<StudyReportRouteIndex />} />
      </Route>
    </Routes>
  );
};

export default StudyReportRoutes;
